const utils = {
  isEven: (num) => num % 2 === 0,
  formatPhoneNumber: (number) =>
    number.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3"),

  mapToOptions: (data, labelKeys, valueKey, separator = " ") => {
    return data.map((item) => {
      let label = "";

      if (Array.isArray(labelKeys)) {
        // join multiple keys with separator
        label = labelKeys.map((key) => item[key]).join(separator);
      } else {
        // single key
        label = item[labelKeys];
      }

      return {
        label,
        value: item[valueKey],
      };
    });
  },
  parseDDMMYYYY: (dateString) => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split("/");
    return new Date(`${year}-${month}-${day}`); // convert → yyyy-MM-dd
  },
  studyColors: () => {
    return [
      { value: "#FF0000", label: "Red" },
      { value: "#000000", label: "Black" },
      { value: "#0000FF", label: "Blue" },
      { value: "#5F9EA0", label: "Cadetblue" },
      { value: "#dda4a4", label: "light Brown" },
      { value: "#00FF00", label: "Green" },
      { value: "#808080", label: "Grey" },
      { value: "#FFA500", label: "Orange" },
      { value: "#FFC0CB", label: "Pink" },
      { value: "#800080", label: "Purple" },
      { value: "#EE82EE", label: "Violet" },
      { value: "#9c8847", label: "Brown" },
      { value: "#000080", label: "Navy blue" },
      { value: "#C0C0C0", label: "Silver" },
      { value: "#CFB53B", label: "Golden" },
      { value: "#FF00FF", label: "Magenta" },
      { value: "#4B0082", label: "Indigo" },
      { value: "#DDA0DD", label: "Plum" },
      { value: "#FF007F", label: "Rose" },
      { value: "#40826D", label: "Viridian" },
      { value: "#D2B48C", label: "Tan" },
      { value: "#708090", label: "Slate gray" },
      { value: "#a0522d", label: "Sangria" },
      { value: "#800000", label: "Maroon" },
      { value: "#c10534", label: "Cranberry" },
      { value: "#2d6d66", label: "Emerald" },
      { value: "#55752f", label: "Forest Green" },
      { value: "#0080ff", label: "Midblue" },
      { value: "#add8e6", label: "Itblue" },
      { value: "#34495e", label: "Wet Asphalt" },
      { value: "#88c440", label: "Light Green" },
      { value: "#835772", label: "Meriot" },
      { value: "#df5757", label: "Flamenco" },
      { value: "#578970", label: "Hunter" },
      { value: "#5d5b66", label: "Timeless" },
      { value: "#eae48e", label: "Wattle" },
      { value: "#b65588", label: "Jive" },
    ];
  },
  uuidv4: () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0xf) >> 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },

  /**
   * Parse common API / UI date values to a Date, or null.
   * Supports ISO strings, dd/MM/yyyy (+ optional time), yyyy-MM-dd (date-only = local midnight).
   */
  parseDateInput(val) {
    if (val == null || val === "") return null;
    if (val instanceof Date)
      return Number.isNaN(val.getTime()) ? null : val;
    if (typeof val === "number") return new Date(val);
    const str = String(val).trim();
    if (/^\d{10,13}$/.test(str)) return new Date(Number(str));

    // dd/MM/yyyy [h:mm[:ss] [AM|PM]] — SQL often returns h:mm tt (no leading zero)
    const dmyMatch = str.match(
      /^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i,
    );
    if (dmyMatch) {
      const [, d, m, y, hh, mm, ss, ampm] = dmyMatch;
      let hour = +(hh || 0);
      const minute = +(mm || 0);
      const second = +(ss || 0);
      if (ampm) {
        const isPm = ampm.toUpperCase() === "PM";
        if (isPm && hour < 12) hour += 12;
        if (!isPm && hour === 12) hour = 0;
      }
      return new Date(+y, +m - 1, +d, hour, minute, second);
    }

    const ymdOnly = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (ymdOnly) {
      const [, y, m, d] = ymdOnly;
      return new Date(+y, +m - 1, +d, 0, 0, 0);
    }

    const ts = Date.parse(str);
    if (!Number.isNaN(ts)) return new Date(ts);
    return null;
  },

  /**
   * Display format: DD/MM/YYYY hh:mm AM/PM (e.g. 07/04/2026 10:55 AM)
   */
  formatDateTimeDisplay(val) {
    const d = utils.parseDateInput(val);
    if (!d)
      return val == null || val === "" || val === "-" ? "—" : String(val);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    let h24 = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = h24 >= 12 ? "PM" : "AM";
    let h12 = h24 % 12;
    if (h12 === 0) h12 = 12;
    const hour = String(h12).padStart(2, "0");
    return `${day}/${month}/${year} ${hour}:${minutes} ${ampm}`;
  },

  isApiSuccess: (response) =>
    response != null &&
    (Number(response.success) === 1 || Number(response.Success) === 1),

  looksLikeDeveloperMessage: (message) => {
    const text = String(message || "").trim();
    if (!text) return false;
    return [
      /\.sql/i,
      /\bre-?run\b/i,
      /\bre-?deploy\b/i,
      /\brebuild the api\b/i,
      /\brestart the api\b/i,
      /\bexception email\b/i,
      /\bcheck sql\b/i,
      /\bdbo\.usp_/i,
      /\bstage 2 script\b/i,
      /could not be saved due to a database error/i,
      /\bplease ensure\b/i,
      /\bif it persists\b/i,
      /incorrect syntax/i,
      /invalid column name/i,
      /could not find stored procedure/i,
    ].some((pattern) => pattern.test(text));
  },

  sanitizeUserFacingMessage: (message, fallback = "") => {
    const text = String(message || "").trim();
    if (!text) return fallback;
    return utils.looksLikeDeveloperMessage(text) ? fallback : text;
  },

  getApiResponseMessage: (response, fallback = "") => {
    if (!response) return fallback;

    const topLevel =
      response.message || response.Message || response.MSG || response.msg;
    if (topLevel != null && String(topLevel).trim()) {
      return utils.sanitizeUserFacingMessage(String(topLevel).trim(), fallback);
    }

    const data = response.data;
    const rows =
      data?.SuccessStory ||
      data?.successStory ||
      (Array.isArray(data) ? data : null);

    if (Array.isArray(rows) && rows.length > 0) {
      const row = rows[0];
      const rowMsg = row?.MSG || row?.Msg || row?.message || row?.Message;
      if (rowMsg != null && String(rowMsg).trim()) {
        return utils.sanitizeUserFacingMessage(String(rowMsg).trim(), fallback);
      }
    }

    const tableRow =
      data?.Tables?.[0]?.Rows?.[0] ||
      data?.tables?.[0]?.rows?.[0] ||
      data?.Table?.[0]?.Row?.[0];

    if (tableRow) {
      const tableMsg =
        tableRow.MSG || tableRow.Msg || tableRow.message || tableRow.Message;
      if (tableMsg != null && String(tableMsg).trim()) {
        return utils.sanitizeUserFacingMessage(String(tableMsg).trim(), fallback);
      }
    }

    return fallback;
  },
};

export default utils;

// export function formatPhoneNumber(number) {
//   return number.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
// }
